import React, { useRef, useState } from "react";
import searchIcon from '../../assets/search-glass.png';
import Icon from 'react-web-vector-icons';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import deleteIcon from '../../assets/components/filters/delete.svg';
import filtersIcon from '../../assets/components/filters/filter.svg';
import { isNullOrEmpty, isNullOrEmptyArray } from "../../utils/general";
import Row from "../Row";
import Button from "../Button";
import Dropdown from "../FormFields/Dropdown";

import './Filters.scss';

const moment = require("moment");

const Filters = props => {
	const { availableFilters, selectedFilters, clearFilters, onAddFilter, onRemoveFilter } = props;
	const [filterSearch, setFilterSearch] = useState('');
	const [tempFilter, setTempFilter] = useState(null);
	const [tempFilterValue, setTempFilterValue] = useState('');
	const [tempFilterOperator, setTempFilterOperator] = useState(null);
	const [showFloater, setShowFloater] = useState(false);
	const [showAddFilter, setShowAddFilter] = useState(false);
	const addFilterBtnRef = useRef(null);
	const [innerFloaterPos, setInnerFloaterPos] = useState({ top: 0, left: 0 });

	const toggleFloater = () => {
		const newValue = !showFloater;
		setShowFloater(newValue);
		if (!newValue) {
			resetTempFilter(); // Call reset function when closing
		}
	};

	const resetTempFilter = () => {
		setTempFilter(null);
		setTempFilterValue('');
		setTempFilterOperator(null);
	};

	const toggleAddFilter = () => {
		const next = !showAddFilter;
		setShowAddFilter(next);
		if (next && addFilterBtnRef.current) {
			const rect = addFilterBtnRef.current.getBoundingClientRect();
			const popupWidth = 300; // matches .filters-inner-floater width
			let left = rect.left;
			if (left + popupWidth > window.innerWidth - 8) {
				left = Math.max(8, window.innerWidth - popupWidth - 8);
			}
			setInnerFloaterPos({ top: rect.bottom + 6 + window.scrollY, left: left + window.scrollX });
		}
	};

	const onSelectFilter = (filter) => {
		setTempFilter(filter);
		// Initialize default value based on filter type so UI previews render immediately
		if (filter.type === 'numeric') {
			setTempFilterValue({ min: 0, max: 500000 });
		} else if (filter.type === 'date') {
			setTempFilterValue('');
		} else {
			setTempFilterValue('');  // Reset value when switching filters
		}
		setTempFilterOperator(null);
		setShowAddFilter(false);
	};

	const onApplyFilter = (operator) => {
		let value = tempFilterValue;
		if (tempFilter.type === "date" && value.toString().indexOf(" - ") < 0) {
			value = moment(tempFilterValue).format("YYYY-MM-DD");
		}
		const filter = {
			name: tempFilter.label,
			key: tempFilter.key,
			type: tempFilter.type,
			value,
			operator: (tempFilterOperator || operator)
		};

		onAddFilter(filter);

		setTempFilter(null);
		setTempFilterOperator(null);
		setTempFilterValue('');
		setShowAddFilter(false);
		setShowFloater(false);
	};

	const toggleFilterValue = (value) => {
		if (isNullOrEmptyArray(tempFilterValue)) {
			setTempFilterValue([value]);
		}
		else if (tempFilterValue.indexOf(value) > -1) {
			setTempFilterValue(tempFilterValue.filter(f => f !== value));
		}
		else {
			setTempFilterValue([...tempFilterValue, value])
		}
	};

	const undoAddValue = () => {
		setTempFilter(null);
		setTempFilterValue('');
	};

	const onRemoveTempFilter = () => {
		setTempFilter(null);
		setTempFilterValue('');
	};

	const updateFilterOperator = (value) => {
		setTempFilterOperator(value);
		if (tempFilter.type != 'date') {
			return;
		}

		if (value.key === 'before' || value.key === 'after' || value.key === 'exactly') {
			if (!tempFilterValue || typeof tempFilterValue === 'string') {
				setTempFilterValue(new Date());
			}
			return;
		}

		setTempFilterValue(getDateRange(value.key));
	};

	const renderTempFilterBox = label => {
		const isEditMode = selectedFilters.find(f => f.name === label) != null;

		if (isEditMode) {
			return null;
		}

		return (
			<div className="filters-floater-temp-filter-box">
				<div className="filters-floater-temp-filter-name">{label}</div>
				<img src={deleteIcon} onClick={() => onRemoveTempFilter()} style={{ cursor: 'pointer', padding: '5px' }} />
			</div>
		)
	};

	const moment = require('moment');

	const getDateRange = (label) => {
		let startDate, endDate;

		switch (label) {
			case 'this_week':
				startDate = moment().startOf('week');
				endDate = moment().endOf('week');
				break;
			case 'this_month':
				startDate = moment().startOf('month');
				endDate = moment().endOf('month');
				break;
			case 'this_quarter':
				startDate = moment().startOf('quarter');
				endDate = moment().endOf('quarter');
				break;
			case 'this_year':
				startDate = moment().startOf('year');
				endDate = moment().endOf('year');
				break;
			case 'last_week':
				startDate = moment().subtract(1, 'week').startOf('week');
				endDate = moment().subtract(1, 'week').endOf('week');
				break;
			case 'last_month':
				startDate = moment().subtract(1, 'month').startOf('month');
				endDate = moment().subtract(1, 'month').endOf('month');
				break;
			case 'last_quarter':
				startDate = moment().subtract(1, 'quarter').startOf('quarter');
				endDate = moment().subtract(1, 'quarter').endOf('quarter');
				break;
			case 'last_year':
				startDate = moment().subtract(1, 'year').startOf('year');
				endDate = moment().subtract(1, 'year').endOf('year');
				break;
			default:
				return 'Invalid label';
		}

		return `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}`;
	}

	const renderTempFilterDate = () => {
		const filterOperators = [
			{ key: 'before', label: 'Before Specified Date', selected: true },
			{ key: 'after', label: 'After Specified Date' },
			{ key: 'exactly', label: 'At Specified Date' },
			{ key: 'this_week', label: 'This Week' },
			{ key: 'this_month', label: 'This Month' },
			{ key: 'this_quarter', label: 'This Quarter' },
			{ key: 'this_year', label: 'This Year' },
			{ key: 'last_week', label: 'Last Week' },
			{ key: 'last_month', label: 'Last Month' },
			{ key: 'last_quarter', label: 'Last Quarter' },
			{ key: 'last_year', label: 'Last Year' }
		];

		const defaultOperator = filterOperators.find(f => f.selected);
		const val = (tempFilterOperator || defaultOperator).key;
		const showPickDate = val === 'before' || val === 'after' || val === 'exactly';
		const isApplyDisabled = showPickDate ? isNullOrEmpty(tempFilterValue) : false;

		return (
			<div className="filters-floater-temp-filter-container">

				{renderTempFilterBox(tempFilter.label)}

				<div className="filters-floater-pick-value-container filters-list-container">
					<div className="filters-list-header">
						<div className="filters-list-title">Filter by Date</div>
						<div className="filters-floater-title-x-container" onClick={undoAddValue}>
							<Icon name="close" font="AntDesign" size={16} />
						</div>
					</div>

					<div className="filters-date-operator">
						<Dropdown
							square
							items={filterOperators}
							onChange={value => updateFilterOperator(filterOperators.find(f => f.key === value))}
							selectedValue={val}
							keyField="key"
							labelField="label"
						/>
					</div>

					{showPickDate && (
						<div className="filters-date-calendar">
							<DayPicker
								mode="single"
								selected={tempFilterValue || undefined}
								onSelect={(date) => setTempFilterValue(date || '')}
								weekStartsOn={1}
								ISOWeek
							/>
						</div>
					)}

					{!showPickDate && (
						<div className="filters-date-preset-hint">Preset range will be applied</div>
					)}

					<div className="filters-list-footer">
						<button
							className={`filters-list-apply ${isApplyDisabled ? 'disabled' : ''}`}
							disabled={isApplyDisabled}
							onClick={() => onApplyFilter(defaultOperator)}
						>
							<Icon name="check" font="Entypo" size={14} style={{ color: '#fff' }} />
							<span style={{ fontSize: '12px' }}>Apply</span>
						</button>
					</div>

				</div>
			</div>
		)
	};

	const renderTempFilterText = () => {
		const filterOperators = [
			{ key: 'is_exact', label: 'Exact match', short: 'Match', selected: true },
			{ key: 'contains', label: 'Contains', short: 'Contains' },
			{ key: 'not_contains', label: 'Does not contain', short: "Doesn't Contain" }
		];

		const defaultOperator = filterOperators.find(f => f.selected);
		const activeOperatorKey = (tempFilterOperator || defaultOperator).key;

		return (
			<div className="filters-floater-temp-filter-container">

				{renderTempFilterBox(tempFilter.label)}

				<div className="filters-floater-pick-value-container filters-list-container">
					<div className="filters-list-header">
						<div className="filters-list-title">{`Filter by ${tempFilter.label}`}</div>
						<div className="filters-floater-title-x-container" onClick={undoAddValue}>
							<Icon name="close" font="AntDesign" size={16} />
						</div>
					</div>

					<div className="filters-text-input">
						<input
							className="filters-text-input-field"
							type="text"
							value={tempFilterValue}
							onChange={e => setTempFilterValue(e.target.value)}
							placeholder="Enter Value"
						/>
					</div>

					<div className="filters-list-segment-txt">
						{filterOperators.map(op => (
							<button
								key={op.key}
								className={`filters-list-seg-btn ${activeOperatorKey === op.key ? 'active' : ''}`}
								onClick={() => updateFilterOperator(op)}
							>
								{op.short}
							</button>
						))}
					</div>

					<div className="filters-list-footer">
						<button
							className={`filters-list-apply ${isNullOrEmpty(tempFilterValue) ? 'disabled' : ''}`}
							disabled={isNullOrEmpty(tempFilterValue)}
							onClick={() => onApplyFilter(defaultOperator)}
						>
							<Icon name="check" font="Entypo" size={14} style={{ color: '#fff' }} />
							<span style={{ fontSize: '12px' }}>Apply</span>
						</button>
					</div>

				</div>
			</div>
		)
	};

	const renderTempFilterNumeric = () => {
		// Range slider UI (0 - 10,000,000 default)
		const minBound = 0;
		const maxBound = 10000000;
		const step = 1000;

		const defaultOperator = { key: 'between', label: 'Between', selected: true };

		const ensureRange = (val) => {
			if (!val || typeof val !== 'object') return { min: 0, max: 500000 };
			const min = Math.max(minBound, Math.min(val.min ?? minBound, maxBound));
			const max = Math.max(min, Math.min(val.max ?? maxBound, maxBound));
			return { min, max };
		};

		const range = ensureRange(tempFilterValue);

		const formatCurrency = (n) => n.toLocaleString(undefined, { maximumFractionDigits: 0 });

		const onMinChange = (v) => {
			const nextMin = Math.min(Number(v), range.max);
			setTempFilterValue({ min: nextMin, max: range.max });
		};

		const onMaxChange = (v) => {
			const nextMax = Math.max(Number(v), range.min);
			setTempFilterValue({ min: range.min, max: nextMax });
		};

		const disabledApply = !(range.min <= range.max);

		return (
			<div className="filters-floater-temp-filter-container">

				{renderTempFilterBox(tempFilter.label)}

				<div className="filters-floater-pick-value-container filters-list-container">
					<div className="filters-list-header">
						<div className="filters-list-title">{`Filter by ${tempFilter.label}`}</div>
						<div className="filters-floater-title-x-container" onClick={undoAddValue}>
							<Icon name="close" font="AntDesign" size={16} />
						</div>
					</div>

					<div className="filters-number-slider">
						<RangeSlider
							min={minBound}
							max={maxBound}
							step={step}
							value={[range.min, range.max]}
							onInput={([min, max]) => setTempFilterValue({ min, max })}
							className="filters-number-range"
						/>
						<div className="filters-number-slider-labels">
							<span>$0</span>
							<span>$10M</span>
						</div>
					</div>

					<div className="filters-number-display">
						${formatCurrency(range.min)} - ${formatCurrency(range.max)}
					</div>

					<div className="filters-list-footer">
						<button
							className={`filters-list-apply ${disabledApply ? 'disabled' : ''}`}
							disabled={disabledApply}
							onClick={() => onApplyFilter(defaultOperator)}
						>
							<Icon name="check" font="Entypo" size={14} style={{ color: '#fff' }} />
							<span style={{ fontSize: '12px' }}>Apply</span>
						</button>
					</div>

				</div>
			</div>
		)
	};

	const setSelectedFilter = filterToSelect => {
		const filter = availableFilters.find(f => f.label === filterToSelect.name);
		setTempFilter(filter);
		setTempFilterOperator(filterToSelect.operator);

		if (filter.type === "date") {
			setTempFilterValue(moment(filterToSelect.value).toDate());
		}
		else if (filter.type === 'numeric') {
			const v = filterToSelect.value;
			if (!v || typeof v !== 'object' || v.min == null || v.max == null) {
				setTempFilterValue({ min: 0, max: 500000 });
			} else {
				setTempFilterValue({ min: Number(v.min), max: Number(v.max) });
			}
		}
		else {
			setTempFilterValue(filterToSelect.value);
		}
	};
	const getDisplayValue = (value, items) => {
    if (!Array.isArray(value)) {
        if (value && typeof value === 'object' && 'min' in value && 'max' in value) {
            const fmt = (n) => Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
            return `${fmt(value.min)} - ${fmt(value.max)}`;
        }
        return value; // Return as is if not an array/object range
    }
		// Convert items into a Map for **faster lookups**
		const itemMap = new Map(
			items.map(item => {
				const normalizedItem = typeof item === 'string' ? { id: item, name: item } : item;
				return [normalizedItem.id, normalizedItem.name]; // Store (id → name) mapping
			})
		);

		return value
			.map(id => itemMap.get(id) || id) // Lookup name or fallback to ID
			.join(", ");
	};


	const renderTempFilterList = () => {
		const currentFilter = availableFilters.find(f => f.label === tempFilter.label);
		const items = currentFilter?.values || [];

		const filterOperators = [
			{ key: 'include', label: 'Include selected values', short: 'Include', selected: true },
			{ key: 'exclude', label: 'Exclude selected values', short: 'Exclude' }
		];

		const defaultOperator = filterOperators.find(f => f.selected);

		// Normalize item structure (convert strings to objects if needed)
		const normalizeItem = (item) => {
			return typeof item === 'string' ? { id: item, name: item } : item;
		};

		const activeOperatorKey = (tempFilterOperator || defaultOperator).key;

		return (
			<div className="filters-floater-temp-filter-container">
				{renderTempFilterBox(tempFilter.label)}

				<div className="filters-floater-pick-value-container filters-list-container">
					<div className="filters-list-header">
						<div className="filters-list-title">{`Filter by ${tempFilter.label}`}</div>
						<div className="filters-floater-title-x-container" onClick={undoAddValue}>
							<Icon name="close" font="AntDesign" size={16} />
						</div>
					</div>

					<div className="filters-list-search">
						<img src={searchIcon} />
						<input
							className="filters-list-search-input"
							type="text"
							value={filterSearch}
							onChange={e => setFilterSearch(e.target.value)}
							placeholder="Search Value..."
						/>
					</div>

					<div className="filters-list-segment">
						{filterOperators.map(op => (
							<button
								key={op.key}
								className={`filters-list-seg-btn ${activeOperatorKey === op.key ? 'active' : ''}`}
								onClick={() => updateFilterOperator(op)}
							>
								{op.short}
							</button>
						))}
					</div>

					<div className="filters-list-options">
						{items
							.filter(item => {
								const normalizedItem = normalizeItem(item);
								return normalizedItem.name
									.toLowerCase()
									.includes(filterSearch.toLowerCase());
							})
							.map(item => {
								const normalizedItem = normalizeItem(item);
								const selected = tempFilterValue?.includes(normalizedItem.id);

								return (
									<div
										key={normalizedItem.id}
										className={`filters-list-option ${selected ? 'selected' : ''}`}
										onClick={() => toggleFilterValue(normalizedItem.id)}
									>
										<Icon
											name="check"
											size={16}
											font="Entypo"
											style={{ opacity: selected ? 1 : 0, color: selected ? '#fff' : '#365A64' }}
										/>
										<span className="filters-list-option-label">{normalizedItem.name}</span>
									</div>
								);
							})}
					</div>

					<div className="filters-list-footer">
						<button
							className={`filters-list-apply ${isNullOrEmptyArray(tempFilterValue) ? 'disabled' : ''}`}
							disabled={isNullOrEmptyArray(tempFilterValue)}
							onClick={() => onApplyFilter(defaultOperator)}
						>
							<Icon name="check" font="Entypo" size={14} style={{ color: '#fff' }} />
							<span style={{ fontSize: '12px' }}>Apply</span>
						</button>
					</div>
				</div>
			</div>
		);
	};


	return (
		<div className="filters-container">
			<div className="filters-button" onClick={toggleFloater}>
				<img src={filtersIcon} style={{paddingRight: '5px'}} />
				<span style={{whiteSpace: 'nowrap', fontSize: 14, fontWeight: 500}}>Search Filters {isNullOrEmptyArray(selectedFilters) ? '' : `(${selectedFilters.length})`}</span>
			</div>

			{
				showFloater &&
				<>
					<div className="filters-floater">
						<div className="filters-floater-title-row" onClick={toggleFloater}>
							<div className="filters-floater-title-row-content">
								<div className="filters-floater-title" onClick={toggleFloater}>Filters</div>
								{!isNullOrEmptyArray(selectedFilters) && <div onClick={clearFilters} className="filters-floater-clear-all">Clear All</div>}
							</div>

							<div className="filters-floater-title-x-container" onClick={toggleFloater}>
								<Icon name="close" font="AntDesign" size={16} />
							</div>
						</div>

						{
							showAddFilter &&
							<div className="filters-inner-floater" style={{ position: 'fixed', top: innerFloaterPos.top, left: innerFloaterPos.left }}>
								<div className="filters-inner-floater-title-row">
									<div className="filters-inner-floater-title">All Filters</div>
									<div className="filters-floater-title-x-container" onClick={toggleAddFilter}>
										<Icon name="close" font="AntDesign" size={16} />
									</div>
								</div>

								{
									availableFilters.map(filter => (
										<div key={filter.label} className="filters-inner-floater-value" onClick={() => onSelectFilter(filter)}>{filter.label}</div>
									))
								}
							</div>
						}

						{
							!isNullOrEmptyArray(selectedFilters) &&
							selectedFilters.map(f => {
								const currentFilter = availableFilters.find(filter => filter.key === f.key);
								const items = currentFilter?.values || [];

								return (
									<div key={f.name} className="filters-floater-selected-filter-container">
										<div className="filters-floater-selected-filter" onClick={() => setSelectedFilter(f)}>
											<div className="filters-floater-selected-filter-title">
												{f.name} <span style={{ margin: '0 10px' }}>|</span> {f.operator.label}
											</div>
											<div className="filters-floater-selected-filter-value">
												{getDisplayValue(f.value, items)}
											</div>
										</div>
										<div className="filters-floater-title-x-container" onClick={() => onRemoveFilter(f)} style={{ cursor: 'pointer', padding: '5px' }}>
											<Icon name="close" font="AntDesign" size={16} />
										</div>
									</div>
								);
							})
						}


						{
							tempFilter &&
							(tempFilter.type === "list" ? renderTempFilterList() :
								tempFilter.type === "text" ? renderTempFilterText() :
									tempFilter.type === "numeric" ? renderTempFilterNumeric() :
										tempFilter.type === "date" ? renderTempFilterDate() : null)
						}

						<div className="filters-floater-add-filter" ref={addFilterBtnRef} onClick={toggleAddFilter}>
							+ Add Filter
						</div>

						{/*<div className="filters-floater-footer" onClick={toggleFloater} />*/}

					</div>
					<div className="filters-floater-background" onClick={toggleFloater} />
				</>
			}
		</div>
	)
};

export default Filters;

